import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Col, Row, Dropdown, DropdownButton, Form, Button } from 'react-bootstrap';
import Confirm from '../../../components/Confirm/Confirm';
import { getDashboards, deleteDashboard } from '../../Dashboards/DashboardsActions';

import pagination from '../../../util/pagination';
import throttle from '../../../util/throttle';

import Loading from '../../../components/Loading/Loading';

import arrowSortIcon from '../../../assets/img/arrow-sort.svg';
import deleteIcon from '../../../assets/img/delete.svg';

// Import Style
import '../../Dashboards/Dashboards.scss';

const CREATED_BY_LABEL = 'Created by';
const UPDATED_BY_LABEL = 'Updated by';
const ACCESSED_BY_LABEL = 'Last accessed by';

class Dashboards extends React.Component {
  static defaultProps = {
    onNext: function() {},
    onBack: function() {}
  };

  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      filter: 'all',
      sort: '-createdDate',
      search: '',
      page: 1,
      boards: [],
      sortName: [
        {
          name: 'Name: A to Z',
          value: 'name'
        },
        {
          name: 'Name: Z to A',
          value: '-name'
        },
      ],
      sortCreatedDate: [
        {
          name: 'Created date: newest first',
          value: '-createdDate'
        },
        {
          name: 'Created date: oldest first',
          value: 'createdDate'
        }
      ],
      sortUpdatedDate: [
        {
          name: 'Updated date: newest first',
          value: '-updatedDate'
        },
        {
          name: 'Updated date: oldest first',
          value: 'updatedDate'
        }
      ],
      sortAccessedDate: [
        {
          name: 'Accessed date: newest first',
          value: '-accessedDate'
        },
        {
          name: 'Accessed date: oldest first',
          value: 'accessedDate'
        }
      ],
    };

    this.getDashboardsThrottled = throttle(this.getDashboards, 500, this);
  }

  componentDidMount() {
    this.getDashboards();
  }

  applySort = sort => {
    this.setState({ sort, page: 1 }, this.getDashboards);
  };

  getDashboards = () => {
    const { search, sort, page } = this.state;
    this.props.getDashboards({ search, sort, page });
  };

  onSearch = e => {
    this.setState({ search: e.target.value, page: 1 }, this.getDashboardsThrottled);
  };

  goto = page => {
    if (page < 1) {
      page = 1;
    }

    this.setState({ page }, this.getDashboards);
  };

  renderSelected = type => {
    const selected = _.find(this.state[type + 'Options'], {
      value: this.state[type]
    });
    return selected ? selected.name : '';
  };

  toggleFilter = () => {
    document.getElementById('filter-content').classList.toggle('shown');
  };

  renderPagination = () => {
    const pages = pagination(this.props.total, this.props.page, 20, 5);

    if (pages.totalPages < 2) {
      return <div></div>;
    }

    return (
      <ul className="pagination">
        {pages.currentPage > 1 && (
          <li aria-label="First" onClick={() => this.goto(1)}>
            <a role="button" href="#">
              «
            </a>
          </li>
        )}
        {pages.currentPage > 1 && (
          <li aria-label="Prev" onClick={() => this.goto(pages.currentPage - 1)}>
            <a role="button" href="#">
              ‹
            </a>
          </li>
        )}
        {pages.pages.map((p, i) => {
          return (
            <li className={p === pages.currentPage && 'active'} key={i} onClick={() => this.goto(p)}>
              <a role="button" href="#">
                {p}
              </a>
            </li>
          );
        })}
        {pages.currentPage < pages.totalPages && (
          <li aria-label="Next" onClick={() => this.goto(pages.currentPage + 1)}>
            <a role="button" href="#">
              ›
            </a>
          </li>
        )}
        {pages.currentPage < pages.totalPages && (
          <li aria-label="Last" onClick={() => this.goto(pages.totalPages)}>
            <a role="button" href="#">
              »
            </a>
          </li>
        )}
      </ul>
    );
  };

  renderTooltip(diff) {
    if (diff > 0) {
      return (
        <p key="tooltip" className='dashboard-tooltip error'>
          It seems that you have more dashboards than your plan allows.
          Please remove <strong>{diff}</strong> of your dashboards or click the Back button to select another
          plan
        </p>
      );
    } else {
      return <p key="tooltip" className='dashboard-tooltip successful'>You can proceed to the next step</p>;
    }
  }

  render() {
    const { dashboards, isLoading, total } = this.props;
    const { model } = this.props;
    const allowed = model.allowed;
    const diff = total - allowed;

    return [
      this.renderTooltip(diff),
      <React.Fragment key="dashboards">
        <div className='dashboard_container'>
          <div className='table-content'>
            <div className='table-filter'>
              <h5>Dashboards activity</h5>
              <div className="u-di form-group">
                <div className='search-wrap'>
                  <input
                    name="search"
                    placeholder="Search"
                    type="text"
                    id="Search"
                    className="form-control"
                    value={this.state.search}
                    onChange={this.onSearch}
                  />
                </div>
              </div>
            </div>

            <div className='table-scroll'>
              <table className='table'>
                <thead>
                  <tr>
                    <th>
                      <div className='flex'>
                        Dashboard name
                        <Form.Group controlId="sort" className="filter-dropdown">
                          <DropdownButton
                            className="form-control-dropdown-sort"
                            id="dropdown-item-button"
                            title={<img src={arrowSortIcon} alt="#" />}
                          >
                            {this.state.sortName.map((s, i) => {
                              return (
                                <Dropdown.Item
                                  key={i}
                                  as="button"
                                  className={ this.state.sort === s.value && 'active' }
                                  onClick={() => this.applySort(s.value)}>
                                  {s.name}
                                </Dropdown.Item>
                              );
                            })}
                          </DropdownButton>
                        </Form.Group>
                      </div>
                    </th>
                    <th>
                      <div className='flex'>
                        {CREATED_BY_LABEL}
                        <Form.Group controlId="sort" className="filter-dropdown">
                          <DropdownButton
                            className="form-control-dropdown-sort"
                            id="dropdown-item-button"
                            title={<img src={arrowSortIcon} alt="#" />}
                          >
                            {this.state.sortCreatedDate.map((s, i) => {
                              return (
                                <Dropdown.Item
                                  key={i}
                                  as="button"
                                  className={ this.state.sort === s.value && 'active' }
                                  onClick={() => this.applySort(s.value)}>
                                  {s.name}
                                </Dropdown.Item>
                              );
                            })}
                          </DropdownButton>
                        </Form.Group>
                      </div>
                    </th>
                    <th>
                      <div className='flex'>
                        {UPDATED_BY_LABEL}
                        <Form.Group controlId="sort" className="filter-dropdown">
                          <DropdownButton
                            className="form-control-dropdown-sort"
                            id="dropdown-item-button"
                            title={<img src={arrowSortIcon} alt="#" />}
                          >
                            {this.state.sortUpdatedDate.map((s, i) => {
                              return (
                                <Dropdown.Item
                                  key={i}
                                  as="button"
                                  className={ this.state.sort === s.value && 'active' }
                                  onClick={() => this.applySort(s.value)}>
                                  {s.name}
                                </Dropdown.Item>
                              );
                            })}
                          </DropdownButton>
                        </Form.Group>
                      </div>
                    </th>
                    <th>
                    <div className='flex'>
                        {ACCESSED_BY_LABEL}
                        <Form.Group controlId="sort" className="filter-dropdown">
                          <DropdownButton
                            className="form-control-dropdown-sort"
                            id="dropdown-item-button"
                            title={<img src={arrowSortIcon} alt="#" />}
                          >
                            {this.state.sortAccessedDate.map((s, i) => {
                              return (
                                <Dropdown.Item
                                  key={i}
                                  as="button"
                                  className={ this.state.sort === s.value && 'active' }
                                  onClick={() => this.applySort(s.value)}>
                                  {s.name}
                                </Dropdown.Item>
                              );
                            })}
                          </DropdownButton>
                        </Form.Group>
                      </div>
                    </th>
                    <th className='width-auto'>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {dashboards.map((d, i) => {
                    return (
                      <tr key={i}>
                        <td>{d.name}</td>
                        <td>
                          <span className='cell-label'>{CREATED_BY_LABEL}</span>
                          {d.createdBy ? (
                            <React.Fragment>
                              <p>{d.createdBy.name}</p>
                              <p>{d.createdBy.email}</p>
                              <p>{d.createdAt ? moment(d.createdAt).format('D MMM YYYY hh:mm A') : '-'}</p>
                            </React.Fragment>
                          ) : (
                            <p>-</p>
                          )}
                        </td>
                        <td>
                          <span className='cell-label'>{UPDATED_BY_LABEL}</span>
                          {d.updatedBy ? (
                            <React.Fragment>
                              <p>{d.updatedBy.name}</p>
                              <p>{d.updatedBy.email}</p>
                              <p>{d.modifiedAt ? moment(d.modifiedAt).format('D MMM YYYY hh:mm A') : '-'}</p>
                            </React.Fragment>
                          ) : (
                            <p>-</p>
                          )}
                        </td>
                        <td>
                          <span className='cell-label'>{ACCESSED_BY_LABEL}</span>
                          {d.accessedBy ? (
                            <React.Fragment>
                              <p>{d.accessedBy.name}</p>
                              <p>{d.accessedBy.email}</p>
                              <p>{d.accessedAt ? moment(d.accessedAt).format('D MMM YYYY hh:mm A') : '-'}</p>
                            </React.Fragment>
                          ) : (
                            <p>-</p>
                          )}
                        </td>
                        <td className='width-auto'>
                          <Confirm
                            onConfirm={() => this.props.deleteDashboard(d._id)}
                            body={
                              <p>
                                Are you sure you want to delete <strong>{d.name}</strong>?
                              </p>
                            }
                            confirmText="Delete"
                            icon={deleteIcon}
                            title="Delete dashboard"
                          >
                            <Button variant='danger' size="md" className='btn-icon'>
                              <img src={deleteIcon} alt="delete" />
                            </Button>
                          </Confirm>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          {this.renderPagination()}
          <div className='action_box_billing'>
            <Button variant='secondary' className='btn_prev' onClick={this.props.onBack}>
              Back
            </Button>
            <Button disabled={diff > 0} variant='primary' className='btn_next' onClick={this.props.onNext}>
              {this.state.loading ? 'Loading...' : 'Next'}
            </Button>
          </div>
        </div>

        {isLoading && (
          <div className='table-loading loader-delay'>
            <Loading />
          </div>
        )}
      </React.Fragment>
    ];
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getDashboards: opt => dispatch(getDashboards(opt)),
    deleteDashboard: id => dispatch(deleteDashboard(id))
  };
};

const mapStateToProps = state => {
  return {
    dashboards: state.boards.boards,
    isLoading: state.boards.loading,
    page: state.boards.page,
    total: state.boards.total,
    model: state.subscription.model
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboards);
